module.exports = __webpack_public_path__ + "img/cb224b0e186eaa8775a119ad48eb5014.png";